import React from 'react';

export const FloridaLogo = ({ className = "h-10 w-auto" }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_slice-concrete/artifacts/vf4hif0h_f3771e95-b6b8-416a-89f7-1bbb7542cb79.JPG"
      alt="Florida Concrete Cutting Services"
      className={className}
    />
  );
};

export default FloridaLogo;
